import { ETenantCode } from "../enums/tenants";

export const getTenantFromUrl = (
  url: string,
  localTenantCode?: string
): ETenantCode | string => {
  if (url.includes(ETenantCode.CAREPLUS)) return ETenantCode.CAREPLUS;
  if (url.includes(ETenantCode.FLEURY)) return ETenantCode.FLEURY;
  if (url.includes(ETenantCode.ACCAMARGO)) return ETenantCode.ACCAMARGO;
  if (localTenantCode) return localTenantCode;

  return ETenantCode.EINSTEIN;
};
